import { Core } from "@faire/design-tokens";
import { HorizontalLine } from "@faire/web/slate/Layout";
import React from "react";
export var HorizontalLineWithColor = function HorizontalLineWithColor() {
  return /*#__PURE__*/React.createElement(HorizontalLine, {
    color: Core.border.muted
  });
};